import { Component } from '@angular/core';

@Component({
  selector: 'stars-anatomy-characters',
  templateUrl: './anatomy-characters.html',
  styleUrls: ['./anatomy-characters.scss']
})
export class AnatomyCharactersComponent {}
